import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { Utility } from '../../../../../../Autofacets-Core/src/app/utils/utility';
import { DealerViewModel } from '../../../business-entities/dealer-view-model';
import { FuelType } from '../../../business-entities/fuel-view-model';
import { RentalCar } from '../../../business-entities/rental-car.interface';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { RentalCarService } from '../../../business-services/rental-car.service';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { Brand } from './../../../business-entities/brand.model';
import { ImageService } from './../../../services/image.service';
import { ModelType, VehicleListViewModel } from '../../../business-entities/vehicle-list-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { VehicleBusinessService } from '../../../business-services/vehicle-service';
import { Features } from '../../../business-entities/user-role-view-model';
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SecureStorage } from '../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import * as CommonEnums from 'projects/Autofacets-Core/src/app/utils/enums';

@Component({
  selector: 'app-add-rental-car',
  templateUrl: './add-rental-car.component.html'
})
export class AddRentalCarComponent implements OnInit {

  RentalCarInfo: RentalCar =
    {
      licensePlatNo: '',
      engineNo: '',
      model: null,
      company: null,
      color: "",
      chessisNo: "",
      charges: null,
      dealerId: null,
      year: null,
      isActive: true,
      registrationDate: null,
      fuel: null,
      image: null,
      mimeType: null,
      carImageBinaryData: null,
      rentalCarImage: null,
      registrationDateTime: null
    };
  selectedColor: string;
  imageBaseData: string | ArrayBuffer = null;
  dealerList: SelectListItemViewModel[];
  brandList: Brand[] = [];
  brand: Brand[];
  fuelType: FuelType[];
  dealers: DealerViewModel[] = [];
  fuels: FuelType[] = [];
  registrationDate: NgbDateStruct;
  today = this.calendar.getToday();
  rentalCarImageName: string;
  selectedDealerId: string = null;
  dealerSelected: string = '';
  isChargesLengthError: boolean = false;
  isValidRentalPrice: boolean = false;
  licensePlateClass: string = "";
  isDisabled: boolean = false;
  isAssociateToMultiDealer: boolean = false;
  modelList: ModelType[] = [];
  modelName: string;
  searchVehicleDetails: VehicleListViewModel;
  features: Features[] = [];
  addRentalCarForm: FormGroup;
  selectedAttributes: any;
  keepExtraFieldsMandatory = true;

  constructor(
    public service: RentalCarService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private calendar: NgbCalendar,
    private userService: UserDataService,
    private globalSetting: GlobalSetting,
    private activeModal: NgbActiveModal,
    private imageService: ImageService,
    private brandService: BrandService,
    private Vehicleservice: VehicleBusinessService,
    private formBuilder: FormBuilder,
    private secureStorage: SecureStorage,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.keepExtraFieldsMandatory = localStorage.getItem("Theme") !== 'mg';
    this.isDisabled = false;
    this.service.isEdit = false;
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.GetAllFuelTypes();
    this.GetAllBrand();
    this.checkId();
    this.initializeForm();
    this.getFeatures();
  }

  OnClose() {
    this.activeModal.close({success : true});
  }
  get cpf() {
    return this.addRentalCarForm.controls;
  }
  initializeForm(): void {
    this.addRentalCarForm = this.formBuilder.group({
      licensePlatNo: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9_ ]*$/)]],
      engineNo: ['', this.keepExtraFieldsMandatory ? [Validators.required] : []],
      color: [''],
      chessisNo: ['', this.keepExtraFieldsMandatory ? [Validators.required] : []],
      charges: ['', [Validators.required]],
      year: ['', this.keepExtraFieldsMandatory ? [Validators.required, Validators.max(new Date().getFullYear()), Validators.min(1850), Validators.pattern(/^\d{4}$/)] : [Validators.max(new Date().getFullYear()), Validators.min(1850), Validators.pattern(/^\d{4}$/)]],
      model: [null, [Validators.required]],
      fuel: [null, this.keepExtraFieldsMandatory ? [Validators.required] : []],
      company: [null, Validators.required],
      dealerName: [null, [Validators.required]],
      registrationDate: [{ value: '', disabled: true }],
      isActive: [false]
    });
  }
  async GetAllFuelTypes() {
    await this.service.GetFuelTypes().then(data => {
      this.fuelType = data.responseObject.result;
      for (let fuel of this.fuelType) {
        this.fuels.push(fuel)
      }
    })
  }

  onChange(value: boolean) {
    this.RentalCarInfo.isActive = value;
  }

  checkId() {
    this.dealerList = this.service.dealerList;
    if (this.dealerList && this.dealerList.length == 1) {
      this.isDisabled = true;
      this.selectedDealerId = this.userService.currentUserValue.dealerId;
      this.dealerSelected = this.dealerList.find(dealer => dealer.value === this.selectedDealerId)?.text;
    }
    else {
      this.isDisabled = false;
    }
  }
  checkLength(event): void {
    if (event.target.value) {
      let inputValue = event.target.value.toString().trim().replace(/^0+/, '');
      if (inputValue.toString().includes(',') || /\s/.test(inputValue)) {
        if (inputValue.split(",").length - 1 > 1) {
          this.isValidRentalPrice = true;
        }
        else if (inputValue.toString().includes('.') && inputValue.toString().includes(',')) {
          this.isValidRentalPrice = true;
        }
        else {
          this.isValidRentalPrice = false;
          let splitedValue = inputValue.toString().split(',');
          let val = splitedValue[0].replace(/\s/g, '');
          this.isChargesLengthError = val.length > 4 ? true : false;
        }
      } else if (inputValue.toString().includes('.')) {
        if (inputValue.split(".").length - 1 > 1) {
          this.isValidRentalPrice = true;
        }
        else if (inputValue.toString().includes('.') && inputValue.toString().includes(',')) {
          this.isValidRentalPrice = true;
        }
        else {
          this.isValidRentalPrice = false;
          let splitedValue = inputValue.toString().split('.');
          let val = splitedValue[0].replace(/\s/g, '');
          this.isChargesLengthError = val.length > 4 ? true : false;
        }
      }
      else {
        this.isValidRentalPrice = false;
        this.isChargesLengthError = inputValue.length > 4 ? true : false;
      }

    }
  }

  setDealer(event: any) {
    if (event) {
      this.selectedDealerId = event;
      this.dealerSelected = this.dealerList.find(x => x.value == event).text;
    }
  }
  onBlur(event) {
    this.RentalCarInfo.charges = event.target.value;
  }

  async GetAllBrand() {
    await this.service.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let item of this.brand) {
        this.brandList.push(item)
      }
    })
  }
  async getFeatures() {
    this.features = this.secureStorage.getKeyData('feature');
  }
  async onMakeSelected(make: string) {
    this.modelList = [];
    this.RentalCarInfo.model = null;
    if (make?.trim()) {
      this.GetAllModel(make);
    }
    this.cdr.detectChanges();
  }
  async GetAllModel(make: string): Promise<void> {
    await this.brandService.GetModelnoDropdownList(make).then(data => {
      this.modelList = data.responseObject;
      if (this.modelList?.length == 0) {
        this.RentalCarInfo.model = null;
      }
    });
  }
  async searchVehicle() {
    let licensePlate = this.addRentalCarForm.get('licensePlatNo').value;
    if (licensePlate.trim() == "") {
      return;
    }
    this.spinner.show();
    await this.Vehicleservice.getVehicleByLicencePlateNo(licensePlate).then((response) => {
      this.searchVehicleDetails = response.responseObject;
      if (response.responseObject.errorCount === 1) {
        this.spinner.hide();
        let tpVehicleSearch = false;
        if (this.secureStorage.getKeyData('feature')) {
          this.features = this.secureStorage.getKeyData('feature');
          if (this.features?.length > 0) {
            let feature = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.ThirdPartyAPI)?.isActive             
            tpVehicleSearch = feature;
          }
        }
        if (tpVehicleSearch) {
          this.dataFactorySearch(licensePlate);
        } else {
          let noVehicleFound = this.translate.instant("lblVehicleNotFound");
          this.toaster.error(noVehicleFound);
        }
        return;
      }
      this.GetAllModel(this.searchVehicleDetails.companyMakeName);
      this.RentalCarInfo.registrationDateTime = this.searchVehicleDetails.registrationDate;
      this.selectedAttributes = this.searchVehicleDetails.fuelTypeId
      this.addRentalCarForm.patchValue({
        company: this.searchVehicleDetails.companyMakeName,
        model: this.searchVehicleDetails.companyModel,
        color: this.searchVehicleDetails.color,
        year: this.searchVehicleDetails.year,
        engineNo: this.searchVehicleDetails.engineSerialNo,
        chessisNo: this.searchVehicleDetails.chassisNo
      });
      this.spinner.hide();
    }, _error => {
      this.spinner.hide()
    });
  }

  async dataFactorySearch(vehicleNo: string) {

    this.spinner.show();
    let noVehicleFound = this.translate.instant("lblVehicleNotFound");
    await this.Vehicleservice.getVehicleFrmoDataFactoryByLicencePlateNo(vehicleNo).then((response) => {
      if (response.responseCode === Constant.SuccessResponseCode) {
        if (response.responseObject[0].personDetail == null) {
          this.toaster.error(noVehicleFound);
          this.spinner.hide();
        }
        else {
          this.spinner.hide();
          if (response.responseObject[0].vehicles != null && response.responseObject[0].vehicles.length > 0) {
            let result = response.responseObject[0].vehicles[0];

            if (!this.empty(result.brandName)) {
              this.GetAllModel(result.brandName);
            }
            this.RentalCarInfo.registrationDateTime = this.empty(result.firstRegistrationDate) ?  "" : result.firstRegistrationDate ;
            let fuelType = this.empty(result.fuelTypeText) ? null : result.fuelTypeText;
            let fuelId = this.fuels.filter(s => s.fuelType.includes(fuelType));
            this.addRentalCarForm.patchValue({
              company: this.empty(result.brandName)?   null : result.brandName,
              model: this.empty(result.modelName) ?  null:result.modelName ,
              color: this.empty(result.colorText) ?  "" : result.colorText,
              fuel: fuelId[0].id,
              year: this.empty(result.modelYear) ?  0 : result.modelYear ,
              engineNo: "",
              chessisNo: this.empty(result.vehicleIdentificationNumber) ?  "" : result.vehicleIdentificationNumber
            });
          }
        }
      }
    }, _error => {
      this.spinner.hide()
    });
  }
  empty(e: any) {
    switch (e) {
      case "":
      case null:
      case undefined:
        return true;
      default:
        return false;
    }
  }
  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.RentalCarInfo.mimeType = files[0].type;
    this.RentalCarInfo.image = files[0].name;
    this.rentalCarImageName = file.name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const isValidFormat = this.imageService.validateImageFormat(this.RentalCarInfo.mimeType);
    if (isValidFormat) {
      reader.onload = (_readerEvent) => {
        me.imageBaseData = reader.result;
        this.RentalCarInfo.carImageBinaryData = reader.result.toString().replace('data:' + this.RentalCarInfo.mimeType + ';base64,', '');
        this.RentalCarInfo.image = me.imageBaseData;
        this.RentalCarInfo.rentalCarImage = me.imageBaseData;
      };
    }
    else {
      this.spinner.hide();
      let imgerrormsg = this.translate.instant("lblImageFormatError");
      this.toaster.error(imgerrormsg);
    }
    reader.onerror = function (_error) {
    };

  }

  AddRentalCar() {
    let addedRentalCarMessage = this.translate.instant("lblAddedRentalCar");
    let alreadyAddedRentalCarMessage = this.translate.instant("lblRentalCarAlreadyAdded");
    let errorMessage = this.translate.instant("lblErrorMessage");
    let errorWarning = this.translate.instant("lblErrorWarningForValue");
    const isValidFormat = this.imageService.validateImageFormat(this.RentalCarInfo.mimeType);
    if (isValidFormat) {
      const viewModel: RentalCar = {
        ...this.addRentalCarForm.value,
        charges: this.globalSetting.getFormattedprice(this.addRentalCarForm.value.charges.trim()),
        mimeType: '',
        registrationDate: Utility.getDateStringToDate(this.RentalCarInfo.registrationDateTime),
        dealerId: this.selectedDealerId
      };
      if (!this.keepExtraFieldsMandatory && this.RentalCarInfo.registrationDateTime === null) {
        viewModel.registrationDate = null;
      }
      this.service.AddRentalCar(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          this.activeModal.close({ success: true });
          this.toaster.success(addedRentalCarMessage);
        }
        else if (res.responseCode === Enums.ErrorCodes.RentalCarAlreadyAdded) {
          this.spinner.hide();
          this.toaster.warning(alreadyAddedRentalCarMessage);
        }
      }, error => {
        this.spinner.hide();
        if (error.status === Enums.ErrorCodes.NotFound) {
          this.toaster.warning(errorWarning);
        }
        else {
          this.toaster.error(errorMessage);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toaster.error(imageErr)
    }
    this.spinner.hide();
  }

  public onChangeIsActive(value: boolean) {
    this.RentalCarInfo.isActive = value;
  }

  onDealerSelected(dealerId: string) {
    if (!dealerId) return;
    this.selectedDealerId = dealerId;
  }
}

